export default function isNewVisual() {
    // let newVisual = JSON.parse(localStorage.getItem('new-visual'));
    // return !!newVisual;
    return false;
}